<ng-container *ngIf="isNotLoading">
<router-outlet>
    </router-outlet>

  <!-- Version Display Component - shown in development or for admin users -->
 
</ng-container>
